package org.example.project.service

import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.jsonObject
import kotlinx.serialization.json.jsonPrimitive
import kotlinx.serialization.json.put
import org.example.project.manager.LumaticaApiManager
import org.example.project.manager.LumaticaApiSettings
import org.w3c.fetch.Headers
import org.w3c.fetch.RequestInit

object PasswordResetApi {
    private val json = Json { ignoreUnknownKeys = true }

    suspend fun request(email: String, mode: String, sprache: String = ""): Boolean {
        if (email.isBlank()) return false
        val raw = postJson(
            "request-json",
            buildJsonObject {
                put("email", email.trim().lowercase())
                put("mode", mode)
                put("sprache", sprache)
            }
        )
        return raw.contains("\"ok\":true")
    }

    private suspend fun postJson(action: String, body: kotlinx.serialization.json.JsonObject): String =
        runCatching {
            val response = window.fetch(
                "${LumaticaApiSettings.getBaseUrl()}/api/passwortreset/$action",
                RequestInit(
                    method = "POST",
                    headers = Headers().apply { append("Content-Type", "application/json") },
                    body = json.encodeToString(body)
                )
            )
                .await()
            response.text().await()
        }.getOrDefault("")

    suspend fun verify(token: String): String? {
        if (token.isBlank()) return null
        val raw = runCatching {
            LumaticaApiManager.call("passwortreset/verify/${apiPart(token)}")
        }.getOrDefault("")
        if (!raw.contains("\"ok\":true")) return null
        return runCatching {
            json.parseToJsonElement(raw).jsonObject["mode"]?.jsonPrimitive?.content.orEmpty()
        }.getOrDefault("").ifBlank { "desktop" }
    }

    suspend fun complete(token: String, password: String): String? {
        if (token.isBlank() || password.isBlank()) return null
        val raw = postJson(
            "complete-json",
            buildJsonObject {
                put("token", token)
                put("password", password)
            }
        )
        if (!raw.contains("\"ok\":true")) return null
        return runCatching {
            json.parseToJsonElement(raw).jsonObject["mode"]?.jsonPrimitive?.content.orEmpty()
        }.getOrDefault("").ifBlank { "desktop" }
    }

    private fun apiPart(value: String): String =
        js("encodeURIComponent")(if (value.isBlank()) "~" else value) as String
}
